import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { GenericBulkUpsertService } from '../services/generic-bulk-upsert.service';
import { GenericBulkUpsertFeatureState, ResetState } from '../store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'generic-bulk-upsert-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class GenericFileUploaderComponent {
  @Output() fileSelected = new EventEmitter<File>();
  @Output() validate = new EventEmitter<void>();
  @Output() downloadTemplate = new EventEmitter<void>();
  @ViewChild('fileInput') fileInput!: ElementRef;

  isDragOver = false;
  selectedFile: File | null = null;
  fileName = '';

  constructor(
      protected store: Store<GenericBulkUpsertFeatureState>, 
      private genericBulkUpsertService: GenericBulkUpsertService
  ) {}

  onDownloadTemplate(): void {
    this.downloadTemplate.emit();
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.selectedFile = files[0];
      this.fileName = this.selectedFile.name;
      this.fileSelected.emit(this.selectedFile);
    }
  }

  onFileChange(event: any): void {
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      this.selectedFile = files[0];
      this.fileName = this.selectedFile.name;
      this.fileSelected.emit(this.selectedFile);
    }
  }

  onValidate(): void {
    if (this.selectedFile) {
      this.validate.emit();
    }
  }

  clearFile(): void {
    this.store.dispatch(new ResetState());
    this.selectedFile = null;
    this.fileName = '';
    this.fileSelected.emit(null);
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
}